module.exports = __webpack_public_path__ + "media/images/creator/monitor/kv@2x-8191581e215e1758746374dfe157e190.png";